import {
  DISPLAY_EVENTS_IN_DDL,
  HIDE_SQUAD_DIALOG,
  DISPLAY_SQUAD_DIALOG,
  DISPLAY_NEXT_MONTH,
  DISPLAY_PREVIOUS_MONTH,
  DISPLAY_TOURNAMENT_SQUADS,
  DISPLAY_SPECIFIC_MONTH,
  DISPLAY_SQUAD_DELETE_MODAL,
  DISPLAY_SQUAD_DELETE_CONFIRM_MODAL,
  HIDE_SQUAD_DELETE_DIALOG
} from './constants';
import moment from 'moment';

const currentDate = moment(new Date());

const itemListInitialState = {
  entries: [],
  month: Number(currentDate.format('M')),
  year: Number(currentDate.format('YYYY')),
  modalVisible: false,
  eventTypes: [],
  modalTitle: '',
  squadDeleteModal: {},
  squadDeleteConfirmModal: {},
  warningMessage: '',
  error: '',
  choices: [],
  confirmation: ''
};

const reducer = (state = itemListInitialState, {type, payload}) => {
  switch (type) {
    case DISPLAY_EVENTS_IN_DDL:
      return {
        ...state,
        ...{eventTypes: payload}
      };

    case HIDE_SQUAD_DIALOG:
      return {
        ...state,
        ...{modalVisible: false}
      };

      case HIDE_SQUAD_DELETE_DIALOG:
        return {
          ...state,
          ...{
            modalVisible: true,
            squadDeleteModal: {
              visible: false
            },
            squadDeleteConfirmModal: {
              visible: false
            }
          }
        };
  
      case DISPLAY_SQUAD_DELETE_MODAL:
         return {
          ...state,
          ...{
            modalVisible: true,
             squadDeleteModal: {
             error: payload.error,
             visible: true
              },
            squadDeleteConfirmModal: {
              visible: false
            }}
        };
  
        case DISPLAY_SQUAD_DELETE_CONFIRM_MODAL:
          return {
            ...state,
            ...{
              modalVisible: true,
              squadDeleteModal: {
                visible: false
              },
              squadDeleteConfirmModal: {
                warningMessage: payload.warningMessage,
                error: payload.error,
                choices: payload.choices,
                confirmation: payload.confirmation,
                visible: true
              }
            }
          };
  
      case DISPLAY_SQUAD_DIALOG:
        return {
          ...state,
          ...{
            modalVisible: true,
            modalTitle: payload,
            squadDeleteConfirmModal: {
              visible: false
            },
            squadDeleteModal: {
              visible: false
            }
          }
        };
          
    case DISPLAY_NEXT_MONTH: {
      const nextMonth = state.month + 1,
            year = nextMonth > 12 ? state.year + 1 : state.year,
            month = nextMonth > 12 ? 1 : nextMonth;

      return {
        ...state,
        ...{
          month: month,
          year: year
        }
      };
    }

    case DISPLAY_PREVIOUS_MONTH: {
      const prevMonth = state.month - 1,
            year = prevMonth < 1 ? state.year - 1 : state.year,
            month = prevMonth < 1 ? 12 : prevMonth;

      return {
        ...state,
        ...{
          month: month,
          year: year
        }
      };
    }

    case DISPLAY_SPECIFIC_MONTH: {
      return {
        ...state,
        ...{
          month: payload.month,
          year: payload.year
        }
      };
    }

    case DISPLAY_TOURNAMENT_SQUADS:
      return {
        ...state,
        ...{entries: payload}
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/tournament/squads/reducer.js